<template>
  <div class="content-item tx-products module-product-list">
    <FilterBar v-if="showFilterBar === '0'" />
    <SearchResults />
  </div>
</template>

<script>
import FilterBar from '@/components/FilterBar'
import SearchResults from '@/components/SearchResults'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'App',
  components: { SearchResults, FilterBar },
  data () {
    return {
      mobile: false,
      showFilterBar: window.app.product_list.filterBar
    }
  },
  computed: {
    ...mapState({
      filterCategories: state => state.filter.filterCategories,
      sortingRelevance: state => state.filter.sortingRelevance,
      sortingAsc: state => state.filter.sortingAsc,
      sortingDsc: state => state.filter.sortingDsc,
      itemsPerPage: state => state.product.itemsPerPage
    })
  },
  methods: {
    ...mapActions([
      'init',
      'filterProducts',
      'updateItemsPerPage'
    ]),
    setBreakpoint () {
      this.mobile = window.innerWidth < 1024
    }
  },
  watch: {
    filterCategories: function () {
      this.filterProducts()
    },
    itemsPerPage: function () {
      this.filterProducts()
    }
  },
  created () {
    // Provide global variables
    this.setBreakpoint() // sets variable mobile true/false
    window.addEventListener('resize', this.setBreakpoint)

    // Set filter params from querystring
    const url = new URL(window.location.href)
    if (url.searchParams.has('filters')) {
      this.$store.commit('filter/setFilterCategories', JSON.parse(url.searchParams.get('filters')))
    }

    // Load initial data
    this.init()

    // Set sorting params from querystring
    if (url.searchParams.has('sortingAsc')) {
      this.$store.commit('filter/setSortingAsc', url.searchParams.get('sortingAsc'))
    }
    if (url.searchParams.has('sortingDsc')) {
      this.$store.commit('filter/setSortingDsc', url.searchParams.get('sortingDsc'))
    }
    if (url.searchParams.has('sortingRelevance')) {
      this.$store.commit('filter/setSortingRelevance', url.searchParams.get('sortingRelevance'))
    }
  }
}
</script>
